import { Directive, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import {
  ParcellaGiudizialeAdapter
} from '../../../components/fascicolo/parcelle-giudiziali-edit/parcella-giudiziale-adapter';
import { CompetenzaParcella } from '../../../models/competenza-parcella';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { SezioneLegaliResponse } from '../../../models/dto/sezione-legali-response';
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { ParcellaGiudiziale } from '../../../models/parcella-giudiziale';
import { QuadroCompensiParcella } from '../../../models/quadro-compensi-parcella';
import { ScaglioneParcella } from '../../../models/scaglione-parcella';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';
import { Categoria } from '../../../models/tipologiche/categoria';
import { Cpa } from '../../../models/tipologiche/cpa';
import { FaseCompensoParcella } from '../../../models/tipologiche/fase-compenso-parcella';
import { Iva } from '../../../models/tipologiche/iva';
import { ValoriRiferimentoParcella } from '../../../models/valori-riferimento-parcella';
import { NumericOperationManager } from '../../../utils/numeric-operation-manager';
import { BaseForm } from '../../base-Form';
import { ParcellaGiudizialeQuadroForm } from './parcella-giudiziale-quadro-form';

@Directive()
export abstract class ParcellaGiudizialeForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  // form
  request: ParcellaGiudiziale;
  riepilogo: ParcellaGiudiziale = null;
  parcellaGiudizialeForm: any;
  msgNoBeneficiari: string;

  // options
  tipiLegale: Categoria[] = [];
  legaliAll: LegaleIncaricato[] = [];
  legaliOptions: LegaleIncaricato[] = [];
  competenzeOptions: CompetenzaParcella[] = [];
  scaglioniOptions: ScaglioneParcella[] = [];
  valoriRiferimentoParcellaOptions: ValoriRiferimentoParcella[] = [];
  ivaOptions: Iva[] = [];
  cpaOptions: Cpa[] = [];

  // importi calcolati
  totaleQuadroCompensi: any = 0;

  // variabili
  quadroCompensi: QuadroCompensiParcella[] = [];
  importoPetitum: any;
  bloccaScaglione: boolean = false;

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;
  visibleToggleRiepilogo: boolean = false;

  @ViewChild('quadroCompensiForm') quadroCompensiForm: ParcellaGiudizialeQuadroForm;

  // parametri abstract
  abstract getParcellaGiudiziale(): ParcellaGiudiziale;
  abstract getRequest(request: ParcellaGiudiziale);
  abstract getUrlReadSezioneLegali(): string;
  abstract getUrlReadSezioneEconomica(): string;
  abstract getUrlGetScaglioni(): string;
  abstract getTipoFascicolo(): any;
  abstract getTipoPratica(): any;
  abstract getIdFascicolo(): string;

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

  initRequest() {
    this.request = new ParcellaGiudizialeAdapter(this.getParcellaGiudiziale()).parcellaGiudiziale;
    if (!this.request.spesa || !this.request.spesa.percSpesaGenerale) {
      this.request.spesa.percSpesaGenerale = 15;
    }

    if (this.importoPetitum) {
      this.request.importoPetitumRiferimento = this.importoPetitum;
    }

    if (!this.inserimento) {
      this.importoPetitum = this.request.importoPetitumRiferimento;
    }
    if (this.request.competenza && this.request.competenza.id !== '-1') {
      this.populateScaglioniAll();
    }
    this.quadroCompensi = [];
    if (this.request.scaglione && this.request.scaglione.id !== '-1') {
      this.populateFasiCompenso(this.request.scaglione.id);
    }
    this.initViewToggle();
    if (this.quadroCompensiForm) {
      this.quadroCompensiForm.resetQuadroCompensi();
    }
  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    this.visibleToggleRiepilogo = false;
    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  createForm() {
    this.initRequest();
    this.parcellaGiudizialeForm = this.campiForm.group({
      id: [this.request.id],
      legale: [this.request.legale],
      tipoLegale: [this.request.legale ? this.request.legale.categoriaLegaleIncaricato : null],
      dataParcella: [this.request.dataParcella, Validators.required],
      numeroParcella: [this.request.numeroParcella],
      competenza: [this.request.competenza, Validators.required],
      scaglione: [this.request.scaglione, Validators.required],
      importoBase: [this.request.importoBase],
      percentualeImportoBase: [this.request.percentualeImportoBase],
      flagIva: [this.request.flagIva],
      iva: [this.request.iva],
      flagCpa: [this.request.flagCpa],
      cpa: [this.request.cpa],
      flagRitenutaAcconto: [this.request.flagRitenutaAcconto],
      importoParcella: [this.request.importoParcella],
      importoPetitumRiferimento: [this.request.importoPetitumRiferimento],
      spesa: [this.request.spesa],
      spesaEsente: [this.request.spesa && this.request.spesa.spesaEsente ? this.request.spesa.spesaEsente : 0],
      spesaTrasferta: [this.request.spesa &&  this.request.spesa.spesaTrasferta ? this.request.spesa.spesaTrasferta : 0],
      altraSpesaImponibile: [this.request.spesa && this.request.spesa.altraSpesaImponibile ? this.request.spesa.altraSpesaImponibile : 0],
      flagSpesaGenerale: [this.request.spesa ? this.request.spesa.flagSpesaGenerale : false],
      percSpesaGenerale: [this.request.spesa &&  this.request.spesa.percSpesaGenerale ? this.request.spesa.percSpesaGenerale : 0],
      fasiCompensi: [this.request.fasiCompensi],
      note: [this.request.note],
      documenti: [this.request.documenti],
    });

  }

  populateSelect() {
    if (this.tipiLegale.length === 0) {
      this.helpers.getCategorieLegaleIncaricato().subscribe(response => this.tipiLegale = response);
    }
    if (this.ivaOptions.length === 0) {
      this.helpers.getIva().subscribe(response => this.ivaOptions = response);
    }
    if (this.cpaOptions.length === 0) {
      this.helpers.getCpa().subscribe(response => this.cpaOptions = response);
    }
    if (this.competenzeOptions.length === 0) {
      this.helpers.getCompetenzeParcellaPratFasc(this.getTipoPratica(), this.getTipoFascicolo()).subscribe(response => this.competenzeOptions = response);
    }
  }

  populateScaglioniAll() {
    this.helpers.getScaglioniParcella().subscribe(response => this.scaglioniOptions = response);
  }

  populateScaglioniFromCompetenza(idCompetenza: string) {
    this.request.scaglione = null;
    if (idCompetenza !== '-1') {
      this.operationService.getScaglioniByFascicolo(this.getUrlGetScaglioni(), this.getIdFascicolo(), idCompetenza).subscribe(response => this.getValoriFromScaglioniByFascicolo(response));
    } else {
      this.request.competenza = null;
    }
  }

  getValoriFromScaglioniByFascicolo(response) {
    this.scaglioniOptions = response.scaglioni;
    if (this.bloccaScaglione) {
      if (this.importoPetitum) {
        for (let s of this.scaglioniOptions) {
          if (s.importoMinimo <= this.importoPetitum && this.importoPetitum <= s.importoMassimo) {
            this.request.scaglione = s;
            this.populateFasiCompenso(s.id);
            break;
          }
        }
      }
      this.scaglioniOptions.sort((leftSide, rigthSide): number => {
        if (leftSide.label < rigthSide.label) { return -1; }
        if (leftSide.label > rigthSide.label) { return 1; }
        return 0;
      });
    }
  }

  populateFasiCompenso(idScaglione: string) {
    if (idScaglione !== '-1') {
      this.helpers.getValoriRiferimentiParcellaByScaglione(idScaglione).subscribe(response => { this.inizializzaQuadro(response); });
    } else {
      this.request.scaglione = null;
    }
  }

  inizializzaQuadro(response) {
    this.valoriRiferimentoParcellaOptions = response;
    this.quadroCompensiForm.valoriRiferimentoParcella = this.valoriRiferimentoParcellaOptions;
    this.quadroCompensiForm.fasiCompensi = this.request.fasiCompensi;
    this.quadroCompensiForm.createQuadroCompensi();
  }

  save() {
    this.getRequest(this.riepilogo);
  }

  readSezioneLegali(idSezioneLegali: string) {
    if (idSezioneLegali) {
      this.operationService.readSezione(this.getUrlReadSezioneLegali(), idSezioneLegali)
        .subscribe(response => this.readSezioneLegaliResponse((<SezioneLegaliResponse>response).sezione));
    }
  }

  readSezioneLegaliResponse(sezioneLegali: SezioneLegali) {
    this.legaliAll = sezioneLegali.legaliIncaricati;
    this.legaliAll = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.revocato === false; });
    this.msgNoBeneficiari = 'Non esistono beneficiari da associare';

    if (this.getParcellaGiudiziale() && !this.inserimento) {
      this.legaliOptions = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.categoriaLegaleIncaricato.id === this.getParcellaGiudiziale().legale.categoriaLegaleIncaricato.id; });
    }
  }

  readSezioneEconomica(idSezioneDatiEconomici: string) {
    if (idSezioneDatiEconomici) {
      this.operationService.readSezione(this.getUrlReadSezioneEconomica(), idSezioneDatiEconomici)
        .subscribe(response => this.readSezioneEconomicaResponse((<SezioneEconomicaResponse>response).sezione));
    }
  }

  readSezioneEconomicaResponse(sezioneEconomica: SezioneEconomica) {
    if (this.inserimento) {
      this.importoPetitum = sezioneEconomica.petitum.importoPetitum;
    } else {
      this.importoPetitum = this.request.importoPetitumRiferimento;
    }
    this.request.importoPetitumRiferimento = this.importoPetitum;
    this.bloccaScaglione = true;
  }

  populateLegali(event: any) {
    if (event.target.value && this.legaliAll.length > 0) {
      this.legaliOptions = this.legaliAll.filter(legale => { return legale.categoriaLegaleIncaricato.id === event.target.value; });
    }
  }

  calcolaCompenso(obj: any) {
    this.getLegale(obj);
    let newFasiCompenso: FaseCompensoParcella[] = [];
    for (let f of this.quadroCompensi) {
      let fase: FaseCompensoParcella = new FaseCompensoParcella();
      if (f.checkedFase) {
        fase.fase = f.fase;
        if (typeof f.compenso === 'string') {
          fase.compenso = NumericOperationManager.stringToNumber(f.compenso);
        } else {
          fase.compenso = f.compenso;
        }
        newFasiCompenso.push(fase);
      }
    }
    if (this.request.spesa && this.request.spesa && this.request.spesa.percSpesaGenerale && Number(this.request.spesa.percSpesaGenerale) > 0) {
      this.request.spesa.flagSpesaGenerale = true;
    } else {
      this.request.spesa.flagSpesaGenerale = false;
    }
    this.request.fasiCompensi = newFasiCompenso;
    this.calcolaTotaleDocumento(this.request);
  }

  calcolaTotaleDocumento(parcellaGiudiziale: ParcellaGiudiziale) {
    parcellaGiudiziale.importoBase = NumericOperationManager.stringToNumber(parcellaGiudiziale.importoBase);
    this.helpers.buildProspettoParcella(parcellaGiudiziale).subscribe(response => this.getTotaleDocumento(response));
  }

  getTotaleDocumento(parcellaGiudiziale: ParcellaGiudiziale) {
    this.goToRiepilogo(parcellaGiudiziale);
  }

  goToRiepilogo(parcellaGiudiziale: ParcellaGiudiziale) {
    this.riepilogo = parcellaGiudiziale;
    this.visibleToggleRiepilogo = true;
    this.visibleToggleForm = false;
  }

  goToAssociaLegale() {
    this.createForm();
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
    this.visibleToggleRiepilogo = false;
  }

  goToForm() {
    this.visibleToggleAssocia = false;
    this.visibleToggleRiepilogo = false;
    this.visibleToggleForm = true;
  }

  associaLegale(legaleIncaricato: LegaleIncaricato) {
    this.getLegale(legaleIncaricato);
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    this.visibleToggleRiepilogo = false;
  }

  getLegale(obj: any) {
    if (obj.id) {
      this.request.legale = this.legaliAll.filter(legale => { return legale.id === obj.id; })[0];
    }
  }

  refresh(quadroCompensiParcella: QuadroCompensiParcella[]) {
    this.quadroCompensi = quadroCompensiParcella;
    this.totaleQuadroCompensi = 0;
    for (let q of quadroCompensiParcella) {
      if (q.checkedFase) {
        this.totaleQuadroCompensi = NumericOperationManager.getSum([this.totaleQuadroCompensi, q.compenso]);
      }
    }
    this.request.importoBase = this.totaleQuadroCompensi;
  }

  checkAtLeastOneFase(): boolean {
    let result = false;
    if (this.quadroCompensiForm && this.quadroCompensiForm.checkAtLeastOneFase() && this.quadroCompensiForm.checkAtLeastOneCompenso()) {
      result = true;
    }
    return result;
  }

  // START - VALIDATION
  formValid(): boolean {
    let result = false;
    if ((!this.request.spesa || (this.request.spesa && this.request.spesa.percSpesaGenerale !== 0)) && this.checkIvaCpa() && this.checkAtLeastOneFase()) {
      result = true;
    }
    return result;
  }


  checkSpese(): boolean {
    let result = false;
    if (this.request.spesa) {
      if (((this.request.spesa.altraSpesaImponibile && this.request.spesa.altraSpesaImponibile.toString().trim().length !== 0)
        || (this.request.spesa.spesaEsente && this.request.spesa.spesaEsente.toString().trim().length !== 0)
        || (this.request.spesa.spesaTrasferta && this.request.spesa.spesaTrasferta.toString().trim().length !== 0))
        && (this.request.spesa.percSpesaGenerale && this.request.spesa.percSpesaGenerale > 0)) {
        result = true;
      } else {
        result = false;
      }
    } else {
      result = true;
    }
    return result;
  }

  checkIvaCpa(): boolean {
    let result = false;
    if (this.request.flagCpa) {
      if (this.request.cpa && this.request.cpa.id !== '-1') {
        result = true;
      }
    } else {
      result = true;
    }
    if (result) {
      if (this.request.flagIva) {
        if (this.request.iva && this.request.iva.id !== '-1') {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = true;
      }
    }
    return result;
  }
  // END - VALIDATION

  private getBeneficiarioLabel(legaleIncaricato: LegaleIncaricato): string {
    let result = '';
    if (legaleIncaricato && legaleIncaricato.legale && legaleIncaricato.legale.tipoPersona) {
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = legaleIncaricato.legale.cognome + ' ' + legaleIncaricato.legale.nome;
      }
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = legaleIncaricato.legale.ragioneSociale;
      }
    }
    return result;
  }
}
